import { ServiceAreaMarker } from './ServiceAreaMarker';
import { useMapContext } from '../../../hooks/MapProvider';
import {
    getPageUrl,
    useAnalyticsClickEvent,
    useAnalyticsViewEvent,
} from 'rwl-ui';
import { ClickTargets, ViewTargets } from 'rwl-shared/dist/models/analytics';
import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models';
import { useContentDetails } from '../../../providers';

export const ServiceAreaMarkers = () => {
    const { neighborhood, clusters, setHoveredServiceAreaPlaceId } =
        useMapContext();
    const { closeDetails } = useContentDetails();
    const sendViewEvent = useAnalyticsViewEvent();
    const sendClickEvent = useAnalyticsClickEvent();

    const handleOnHover = (
        serviceArea: NeighborhoodServiceAreaInfo,
        action: string
    ) => {
        if (action === 'enter') {
            setHoveredServiceAreaPlaceId(serviceArea.placeInfo?.place_id);
            sendViewEvent({
                url: getPageUrl(),
                target: ViewTargets.SERVICE_AREA_SUMMARY,
                serviceArea: serviceArea.postcode,
            });
        } else {
            setHoveredServiceAreaPlaceId(undefined);
        }
    };

    const handleOnClick = (serviceArea: NeighborhoodServiceAreaInfo) => {
        closeDetails();
        sendClickEvent({
            url: getPageUrl(),
            target: ClickTargets.SERVICE_AREA,
            serviceArea: serviceArea.postcode,
        });
    };

    return (
        <>
            {!neighborhood &&
                clusters.map((cluster, index) => {
                    const {
                        centroid: position,
                        serviceAreas: areas,
                        totalJobs,
                    } = cluster;
                    if (totalJobs === 0) {
                        return null;
                    } else if (areas.length === 1) {
                        const area = areas[0];
                        return (
                            <ServiceAreaMarker
                                key={index}
                                position={position}
                                serviceArea={area}
                                onHover={(action: string) =>
                                    handleOnHover(area, action)
                                }
                                onClick={() => handleOnClick(area)}
                            />
                        );
                    } else {
                        return (
                            <ServiceAreaMarker
                                key={index}
                                position={position}
                                totalJobs={totalJobs}
                                isCluster={true}
                                serviceAreas={areas}
                                onHover={(action: string) =>
                                    handleOnHover(areas[0], action)
                                }
                                onClick={() => handleOnClick(areas[0])}
                            />
                        );
                    }
                })}
        </>
    );
};
